import gql from 'graphql-tag';

import TweetMetadata from './tweet_metadata';
import UrlMetadata from './url_metadata';
import S3Object from './s3_object';

export default gql`
  fragment ContentObject on ContentObject {
    post_type
    metadata_keys
    title
    body
    url
    photos {
      ...S3Object
    }
    media {
      video {
        bucket
        key
        region
        playlist
        poster
        thumbnails
        status
      }
    }
    url_metadata {
      ...UrlMetadata
    }
    tweet_metadata {
      ...TweetMetadata
    }
    youtube_metadata {
      video_id
    }
    instagram_metadata {
      id
      shortcode
    }
    reddit_metadata {
      url
    }
  }
  ${UrlMetadata}
  ${TweetMetadata}
  ${S3Object}
`;
